import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const OrderChangeNewBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-emerald-600 text-primary-foreground">
      {t('component:badge.orderChangeNew')}
    </Badge>
  );
};
